module.exports = __webpack_public_path__ + "static/logo-80f193440b23fb9f7d0bc9df3e5d81a1.svg";